import React, { Component } from 'react';
import _ from 'lodash';
import { Paper, FloatingActionButton, LinearProgress, RaisedButton } from 'material-ui';
import ContentAdd from 'material-ui/svg-icons/content/add';
import muiThemeable from 'material-ui/styles/muiThemeable';
import { PushesList } from '../components';
import EmptyIcon from 'material-ui/svg-icons/social/notifications';
import firebase from '../firebase';
import withFirestorePath from '../components/withFirestorePath';

const styles = {
  root: {
    padding: 20,
    margin: '0 auto'
  },
  form: {
  },
  paper: {
    padding: 20,
  },
  gridList: {
    width: '100%',
    height: '100%',
    overflowY: 'auto',
  },
  saveButton: {
    marginTop: 15,
  }
};


const PushesEmpty = ({ onClick }) => (
  <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
    <EmptyIcon style={{ width: 400, height: 400, color: '#afafaf' }}/>
    <h4 style={{ color: '#afafaf'}}>You haven't sent any push notifications</h4>
    <RaisedButton label="Send a Push Notification" secondary onClick={onClick}/>
  </div>
);

class Pushes extends Component {
  state = {
    messages: null,
  }

  async componentDidMount() {
    await this.loadData();
  }

  loadData = async () => {
    const { restaurantPath } = this.props;

    const messageSnaps = await restaurantPath
      .collection('messages')
      .orderBy('createdAt', 'desc')
      .get();

    const messages = messageSnaps.docs.map(doc => doc.data());

    this.setState({
      messages
    })
  }

  onDuplicate = async (old) => {
    const { restaurantPath } = this.props;

   await restaurantPath
      .collection('messages')
      .add({ 
        ...old,
        createdAt: new Date(),
      });

    this.loadData();
  }

  render() {
    const { history, muiTheme, params } = this.props;

    const { accent1Color } = muiTheme.palette;

    const restaurantId = params.restaurantId;

    if(!this.state.messages ) return <LinearProgress color={accent1Color} />;

    if(_.isEmpty(this.state.messages)) {
      return (
        <div style={styles.root}>
          <PushesEmpty onClick={() => this.props.router.push(`/${restaurantId}/create-push`)}/>
        </div>
      )
    }

    return (
      <div style={styles.root}>
        <h1>Push Notifications</h1>
        <RaisedButton
          style={{ marginBottom: 5 }}
          label="Send Push Notification"
          onTouchTap={() => this.props.router.push(`/${restaurantId}/create-push`)}
          secondary />
          <Paper style={styles.paper}>
            <PushesList
              onDuplicate={this.onDuplicate}
              data={this.state.messages}
            />
          </Paper>
      </div>
    );
  }
}

export default muiThemeable()(withFirestorePath(Pushes));


// WEBPACK FOOTER //
// ./src/pages/Pushes.js